import React from 'react';
import Header from 'components/@common/PageHeader';
import { LessonPlannerViewToggle } from '.';
import Main from 'Main';

export const LessonPlanAppHeader = ({ children, ...props }: any) => {
  const headerProps = {
    getTitle: () => 'title',
    translationKey: 'lessonPlanner',
    endAdornment: <LessonPlannerViewToggle />,
    ...props
  };

  return (
    <Main>
      <Header {...headerProps} />
      {children}
    </Main>
  );
};
